import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "login",
  class: "flex flex-column text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-5" }, "Login", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "If you don't already have an account:", -1)

import UserLogin from '@/components/UserLogin.vue';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();

function onGoToRegister(){
  router.push('/register');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(UserLogin, { class: "mx-auto" }),
    _hoisted_3,
    _createVNode(_unref(Button), {
      label: "Go to registration",
      class: "mx-auto",
      onClick: onGoToRegister
    })
  ]))
}
}

})